import React from 'react';
const Example = (props) => (<div>
        <span className="partner__avatar">
            <img width="28" height="28" alt="Josef Dobrovský" title="Josef Dobrovský" className="d-block rounded-circle partner__image" src="https://dummyimage.com/56x56/9fa4a8/fff.png&text=AD"/>
        </span>
        <span className="partner__avatar">
            <img width="28" height="28" alt="Josef Jungman" title="Josef Jungman" className="d-block rounded-circle partner__image" src="https://dummyimage.com/56x56/9fa4a8/fff.png&text=AD"/>
        </span>
        <span className="partner__avatar">
            <img width="28" height="28" alt="Karel Hynek Mácha" title="Karel Hynek Mácha" className="d-block rounded-circle partner__image" src="https://dummyimage.com/56x56/9fa4a8/fff.png&text=AD"/>
        </span>
        <span className="partner__avatar">
            <img width="28" height="28" alt="Božena Němcová" title="Božena Němcová" className="d-block rounded-circle partner__image" src="https://dummyimage.com/56x56/9fa4a8/fff.png&text=AD"/>
        </span>
        <span className="partner__avatar">
            <img width="28" height="28" alt="Václav Thám" title="Václav Thám" className="d-block rounded-circle partner__image" src="https://dummyimage.com/56x56/9fa4a8/fff.png&text=AD"/>
        </span>
        <span className="partner__avatar partner__avatar--aggregation pb-3" title="Karel Jaromír Erben, Jan Svatopluk Presl, František Martin Pelcl, Magdalena Dobromila Rettigová, František Palacký a Karel Ignác Thám">
            +6
        </span>
    </div>);
export default Example;
